import React, { useState } from "react";
import { ReactComponent as Visible } from "./icons/visible.svg";
import { ReactComponent as Invisible } from "./icons/invisible.svg";
import cx from "classnames";

type Props = {
  placeholder: string;
  value: string;
  isHelp?: boolean;
  helpText?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const PasswordInput: React.FC<Props> = ({
  placeholder,
  helpText,
  isHelp,
  className,
  value,
  onChange,
}): JSX.Element => {
  const [isVisible, setVisible] = useState(false);

  const handleClick = () => {
    setVisible(!isVisible);
  };

  return (
    <div className={cx("flex flex-col min-w-0", className)}>
      <div
        className={cx(
          "flex flex-row border-b font-nunito border-bt-gray",
          isHelp ? "border-bt-red my-1" : "my-2"
        )}
      >
        <input
          className={cx(
            "w-full border-none mr-3 px-2 py-2 font-nunito border-transparent focus:border-transparent focus:ring-0"
          )}
          type={isVisible ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          autoComplete="off"
        />
        <span className="absolute ml-80 mt-3" onClick={handleClick}>
          {isVisible ? <Visible /> : <Invisible />}
        </span>
      </div>
      {isHelp && helpText && (
        <div className="flex flex-row">
          <span className="font-nunito mt-1 text-xs text-bt-red">
            {helpText}
          </span>
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
